import Vuex, { StoreOptions } from "vuex";
import { mainModule } from "./main";
import { State } from "./state";
import { adminModule } from "./admin";
import { taskModule } from "./task";
import { WorkbenchModule } from "./Workbench";
import { deviceModule } from "./device";
import { logModule } from "./log";
import { projectModule } from "./project";
import { PerformanceModule } from "./performance";

const storeOptions: StoreOptions<State> = {
  modules: {
    main: mainModule,
    admin: adminModule,
    task: taskModule,
    workbench: WorkbenchModule,
    device: deviceModule,
    log: logModule,
    project: projectModule,
    performance: PerformanceModule,
  },
};

export const store = new Vuex.Store<State>(storeOptions);
